import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import "../../styles/components/_account-button-bar.scss";
//import CheckIcon from "../../assets/check.png";
//import { getRemainingCount } from "../../utils";

interface Tab {
  label: string;
  component: React.ReactNode;
}

interface AccountButtonBarProps {
  tabs: Tab[];
  sendPrintData: () => void;
  allPositionsFilled: boolean;
  imagesData: any[];
  confirmationChecked: boolean;
  sent: boolean;
}

const AccountButtonBar: React.FC<AccountButtonBarProps> = ({
  tabs,
  sendPrintData,
  allPositionsFilled,
  confirmationChecked,
  sent,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [completedTabs, setCompletedTabs] = useState<boolean[]>(
    Array(tabs.length).fill(false)
  );
  const isNextButtonEnabled = allPositionsFilled;
  const isTabDisabled = (index: number) => {
    return (index === 1 || index === 2) && !isNextButtonEnabled;
  };
  const handleTabClick = (index: number) => {
    if (!isTabDisabled(index)) {
      setActiveTab(index);
    }
  };

  const handleNext = () => {
    if (activeTab < tabs.length - 1 && !isTabDisabled(activeTab + 1)) {
      setActiveTab(activeTab + 1);
    }
  };
  const { t } = useTranslation();
  const handleBack = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
  };
  const handleSendPrintData = () => {
    sendPrintData();
    const updatedCompletedTabs = [...completedTabs];
    updatedCompletedTabs[activeTab] = true;
    setCompletedTabs(updatedCompletedTabs);
    if (activeTab === tabs.length - 1) {
      const updatedTabs = [...updatedCompletedTabs];
      updatedTabs[activeTab] = true;
      setCompletedTabs(updatedTabs);
    }
  };

  return (
    <div className="account-button-bar">
      <div className="account-button-bar__button-bar">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`account-button-bar__button ${
              activeTab === index ? "account-button-bar__button--active" : ""
            } rounded-full ${
              isTabDisabled(index) ? "account-button-bar__button--disabled" : ""
            }`}
            onClick={() => handleTabClick(index)}
            disabled={isTabDisabled(index)}
            data-tooltip-id={!allPositionsFilled ? "tooltip" : ""}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="account-button-bar__tab-content">
        {tabs[activeTab].component}
      </div>

      <div className="flex mt-4 w-full justify-between">
        {activeTab > 0 && (
          <div className="flex justify-start w-full">
            <button
              className="px-4 py-2 bg-black text-white rounded-full w-48"
              onClick={handleBack}
            >
              {t("back")}
            </button>
          </div>
        )}
        <div className="flex justify-end w-full">
          {!sent && (
            <>
              {activeTab < tabs.length - 1 ? (
                <div>
                  <button
                    className={`px-4 py-2 rounded-full w-48 border-2 transition-all ${
                      isNextButtonEnabled
                        ? "bg-[#0066CC] text-white hover:bg-white hover:text-[#0066CC] hover:border-[#0066CC] border-[#0066CC]"
                        : "bg-[#80B3E6] text-white border-[#80B3E6] cursor-not-allowed"
                         
                    }`}
                    onClick={handleNext}
                    disabled={!isNextButtonEnabled}
                    data-tooltip-id={!allPositionsFilled ? "tooltip" : ""}
                  >
                    {t("next")}
                  </button>
                  {!allPositionsFilled && (
                    <Tooltip id="tooltip" place="top" variant="warning">
                      You must upload all images before advancing.
                    </Tooltip>
                  )}
                </div>
              ) : (
                <div>
                  <button
                    className={`px-4 py-2 text-white rounded-full w-48 ${
                      confirmationChecked
                        ? "bg-blue-600"
                        : "bg-gray-400 cursor-not-allowed"
                    }`}
                    onClick={handleSendPrintData}
                    disabled={!confirmationChecked}
                  >
                    {t('sendPrintdata')}
                  </button>
                  {!allPositionsFilled && (
                    <Tooltip id="tooltip" place="top" variant="warning">
                      You must upload all images before submission.
                    </Tooltip>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountButtonBar;
